import { getEnumItems } from '@/enums/getEnumItems'
import { DropDownList } from '@/components/dropDownList'
import React, { useMemo } from 'react'
import { useLocalization } from '@/hooks/localization'

function EnumDropDownList ({ enumDefinition, value, onChange, allowClear, ...rest }) {
  const { localize } = useLocalization()
  const data = useMemo(() => getEnumItems(localize, enumDefinition), [enumDefinition, localize])
  return (
    <DropDownList
      textField='text'
      valueField='value'
      data={data}
      value={value}
      onChange={onChange}
      allowClear={allowClear} {...rest} />
  )
}

export {
  EnumDropDownList
}



// WEBPACK FOOTER //
// ./src/components/enumDropDownList.js